import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import image11 from '../images/image11.jpeg' 

function Contact() {
  const form = useRef()
  const [status, setStatus] = useState({ type: '', message: '' })

  const sendEmail = (e) => {
    e.preventDefault()
    setStatus({ type: 'sending', message: 'Sending your message...' })

    emailjs
      .sendForm(
        'service_xq3hcfb',
        'template_83kb6kg',
        form.current,
        '2EJJgjhc3qkkv_bVb'
      )
      .then(() => {
        setStatus({ type: 'success', message: 'Your message has been sent successfully.' })
        form.current.reset()
      })
      .catch(() => {
        setStatus({ type: 'error', message: 'Something went wrong. Please try again later.' })
      })
  }

  return (
    <div>
      <div className='section'>
        <div className='text-section'>
          <div className='text-content'>
            <h1 className='section-title'>Contact Us</h1>
            <p>Get in touch with Decor Delights & Events for elegant event decoration services. We're ready to create stunning spaces that make every celebration truly unforgettable.</p>
            <p>Tel: +1 423-430-5282 <br /> Email: info@Decorevents.com</p>
          </div>
        </div>

        <div className='image-section'>
          <img src={image11} alt='Event' className='carousel' />
        </div>
      </div>

      <div className='contact-section'>
        <div className='contact-form-container'>
          <form ref={form} onSubmit={sendEmail} className='contact-form'>
            <div className='form-group'>
              <label htmlFor='first_name'>First Name *</label>
              <input type='text' id='first_name' name='first_name' required />
            </div>

            <div className='form-group'>
              <label htmlFor='last_name'>Last Name *</label>
              <input type='text' id='last_name' name='last_name' required />
            </div>

            <div className='form-group'>
              <label htmlFor='email'>Email *</label>
              <input type='email' id='email' name='email' required />
            </div>

            <div className='form-group'>
              <label htmlFor='subject'>Subject</label>
              <input type='text' id='subject' name='subject' />
            </div>

            <div className='textarea-group'>
              <label htmlFor='message'>Message</label>
              <textarea id='message' name='message' rows='8' required></textarea>
            </div>

            <div className='button-container'>
              <button type='submit' className='submit-button'>Submit</button>
            </div>

            {status.message && (
              <p className={status.type === 'success' ? 'success-message' : 'error-message'}>
                {status.message}
              </p>
            )}
          </form>
        </div>

        <div className='text-section'>
          <div className='text-content'>
            <h1 className='section-title'>Get In Touch</h1>
            <p>Let’s plan your wedding with precision, creativity, and a seamless guest experience.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact